import { ICollectionMapper } from '../Firestore/ICollectionMapper'
import { Barcode, IBarcode } from './Barcode'

export class BarcodeMapper implements ICollectionMapper<Barcode> {
  map(data: IBarcode): Barcode {
    const barcode = new Barcode()

    barcode.id = data.id
    barcode.upc = data.upc
    barcode.title = data.title
    barcode.description = data.description
    barcode.brand = data.brand
    barcode.model = data.model
    barcode.dimension = data.dimension
    barcode.weight = data.weight
    barcode.image = data.image
    barcode.category = data.category

    return barcode
  }

  serialize(object: Barcode): IBarcode {
    return JSON.parse(JSON.stringify(object))
  }
}
